import { Clock3, DollarSign } from "lucide-react";

import type { RendererProps } from "../types";

import { cn } from "@/lib/utils";
import { CellContentType } from "@/routes/smart-table/utils/contentType";

export function ExecutionMetricRenderer({ content }: RendererProps) {
  const isPrice = content.type === CellContentType.PRICE;
  const Icon = isPrice ? DollarSign : Clock3;
  const metric = content.metricPayload;
  const value = metric?.formattedValue || content.displayPreview;
  const rawNumber = metric?.rawNumber;

  return (
    <div className="mx-auto flex w-full max-w-sm flex-col items-center justify-center rounded-2xl border border-border/70 bg-muted/20 px-8 py-10 text-center shadow-sm">
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-border/70 bg-background shadow-sm">
        <Icon className="h-5 w-5 text-muted-foreground" aria-hidden="true" />
      </div>
      <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {metric?.label ?? (isPrice ? "Price" : "Duration")}
      </div>
      <div className="mt-2 max-w-full truncate font-mono text-3xl font-semibold tracking-tight text-foreground">
        {value || <span className="italic text-muted-foreground">Empty</span>}
      </div>
      {rawNumber !== null && rawNumber !== undefined ? (
        <div className={cn("mt-3 text-xs text-muted-foreground", isPrice && "tabular-nums")}>
          Raw: {rawNumber.toLocaleString()} {metric?.unit}
        </div>
      ) : null}
    </div>
  );
}
